// hooks/useCreateBox.js - Custom hook for creating boxes
import { useState } from 'react';
import { boxService } from '../services/boxService';

export function useCreateBox() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createBox = async (boxData) => {
    setLoading(true);
    setError(null);

    try {
      // Validate required fields
      if (!boxData.box_id?.trim()) {
        throw new Error('Box ID is required');
      }
      if (!boxData.title?.trim()) {
        throw new Error('Title is required');
      }

      // Prepare the data
      const payload = {
        box_id: boxData.box_id.trim(),
        title: boxData.title.trim(),
        description: boxData.description?.trim() || '',
        location: boxData.location || 'UCS'
      };

      const result = await boxService.createBox(payload);
      return result;
    } catch (err) {
      const errorMessage = err.response?.data?.detail || err.message || 'Failed to create box';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError(null);

  return {
    createBox,
    loading,
    error,
    clearError
  };
}